<div class="row attendance-summary-row attendance-row ">
    <div class="col-2">
        <div class="row">
            <div class="col-6">{{ summaryItem.date.value | date: 'MMM dd'  }}</div>
            <div class="col-3 text-center">{{ summaryItem.totalHours | number: '1.1' }}</div>
            <div class="col-3 text-center">{{ summaryItem.totalCost | currency }}</div>
        </div>
    </div>
</div>
<div class="row attendance-row " *ngFor="let classItem of summaryItem.classes">
    <div class="col-2"></div>
    <div class="col-10">
        <div class="row align-items-center" >
            <div class="col-2">{{ classItem.clubShortName }}</div>
            <div class="col">{{ classItem.instructorName }}
                <span class="attendance-substitution" *ngIf="classItem.substitution">(sub)</span>
            </div>
            <div class="col">{{ classItem.category }}</div>
            <div class="col">
                <span class="ic_cancelled" *ngIf="classItem.cancelled"
                    tooltip="{{ 'AttendanceReport.CancelledClass' | translate }}" placement="bottom"></span>

                {{ classItem.className }}
            </div>
            <div class="col">{{ classItem.startTime | timeDisplay }}</div>
            <div class="col-1 text-center">{{ classItem.actualLengthOfClass }} {{ classItem.billableLengthOfClass }}</div>
            <div class="col-1 text-center">
                    <span class="ic_payrate" *ngIf="classItem.cost === null"
                    tooltip="{{ 'AttendanceReport.PayrateNotProvided' | translate }}" placement="bottom"></span>
                    <span *ngIf="classItem.cost !== null">{{ classItem.cost | currency }}</span></div>
            <div class="col-1 text-center"><span class="ic_attendance" *ngIf="!attendanceProvided(classItem)"
                    tooltip="{{ 'AttendanceReport.ZeroAttendance' | translate }}" placement="bottom"></span>
                <span *ngIf="attendanceProvided(classItem)">{{ classItem.classAttendance }}</span> </div>

            <div class="col-1 text-center">{{ classItem.costPerHead | currency }}</div>

        </div>
    </div>
</div>
